// extracted by mini-css-extract-plugin
export default {"Login":"styles_Login__mYrG0","forwardsArrow":"styles_forwardsArrow__GptYP","vtInput":"styles_vtInput__xFl6n","rightSlot":"styles_rightSlot__0vuka"};